import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import { scaleOrdinal } from "d3-scale";
import { schemeCategory10 } from "d3-scale-chromatic";
// Create a color scale with d3-scale
const colorScale = scaleOrdinal(schemeCategory10);

const renderLegend = (props: any) => {
  const { payload } = props;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      {payload.map((entry: any, index: any) => (
        <div
          key={`item-${index}`}
          style={{
            marginBottom: "10px",
            display: "flex",
            gap: 5,
            justifyContent: "center",
          }}
        >
          <div
            style={{
              background: entry.color,
              width: 12,
              height: 12,
              borderRadius: "50%",
              marginTop: 3,
            }}
          />
          <span style={{ color: "#fff", fontWeight: 500 }}>
            <span>{entry.value}</span>
            <br />
            <span>{entry.payload.value}</span>
          </span>
        </div>
      ))}
    </div>
  );
};

type VoucherData = {
  name: string;
  value: number;
};

type Props = {
  data: VoucherData[];
};

const VoucherChart: React.FC<Props> = ({ data }) => {
  return (
    <div style={{ width: 350, height: 180 }}>
      <ResponsiveContainer aspect={1.8}>
        <PieChart>
          <Pie
            data={data}
            innerRadius={60}
            outerRadius={80}
            fill="#8884d8"
            stroke="transparent"
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell
                stroke="5"
                style={{ outline: "none" }}
                key={`cell-${index}`}
                fill={colorScale(index.toString())}
              />
            ))}
          </Pie>
          <Tooltip />
          <Legend
            iconType="circle"
            iconSize={12}
            layout="vertical"
            verticalAlign="middle"
            align="right"
            content={renderLegend}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default VoucherChart;
